/**
 * 动态加载高德地图 JS API
 * 从环境变量读取 Key 和安全密钥
 */

let loadPromise: Promise<typeof AMap> | null = null

export function loadAMap(): Promise<typeof AMap> {
  // 如果已经加载过，直接返回
  if (window.AMap) {
    return Promise.resolve(window.AMap)
  }

  // 如果正在加载，返回同一个 Promise
  if (loadPromise) {
    return loadPromise
  }

  loadPromise = new Promise((resolve, reject) => {
    const key = import.meta.env.VITE_AMAP_KEY
    const securityCode = import.meta.env.VITE_AMAP_SECURITY_CODE

    if (!key) {
      reject(new Error('缺少环境变量 VITE_AMAP_KEY'))
      return
    }

    // 设置安全密钥
    window._AMapSecurityConfig = {
      securityJsCode: securityCode || '',
    }

    // 动态创建 script 标签
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = `https://webapi.amap.com/maps?v=2.0&key=${key}`

    script.onload = () => {
      if (window.AMap) {
        resolve(window.AMap)
      } else {
        reject(new Error('高德地图 API 加载失败'))
      }
    }

    script.onerror = () => {
      loadPromise = null
      reject(new Error('高德地图脚本加载失败'))
    }

    document.head.appendChild(script)
  })

  return loadPromise
}

// 扩展 Window 类型
declare global {
  interface Window {
    _AMapSecurityConfig?: {
      securityJsCode: string
    }
  }
}
